@if (shape()) {
  <i [ngClass]="{ disabled: disabled() }" [ngStyle]="style()" [innerHtml]="shape()"></i>
} @else {
  <img
    [ngClass]="{ disabled: disabled() }"
    [ngStyle]="style()"
    [src]="src()"
    (error)="fallbackToIcon()"
  />
}
